<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

<div role="button" tabindex="0" class="chat-header {$chatSession.operatingSystem === 'android' ? 'mobile' : ''}" data-testid="chat-widget-header">
	<div class="image-box">
		<img class="header-logo" src="floraIconUpdate.svg" alt="Chat logo" />
	</div>
	<div class="buttons">
		<button
			data-testid="chat-widget-header-minimize-button"
			class="minimize-button"
			on:click={minimizeChat}
			aria-label="Minimize chat"
		>
			<img src="collapse.svg" width="35" height="35" alt="Minimize" />
		</button>
		<div class="dropdown">
			<button
				data-testid="chat-widget-header-close-button"
				class="close-button"
				on:click={toggleDropdown}
				aria-haspopup="true"
				aria-expanded={dropdownOpen}
				aria-label="More options"
			>
				<img
					class="more-options"
					src="more-options.svg"
					width="35"
					height="35"
					alt="More Options"
				/>
			</button>
			<ul
				class="dropdown-menu {dropdownOpen ? 'open' : ''}"
				role="menu"
				aria-hidden={!dropdownOpen}
			>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<li role="menuitem" tabindex="0" on:click={toggleNotiications}>
					<div class="dropdown-item-img">
						{#if $notificationSoundEnabled}
							<img src="chatNotificationsOn.svg" alt="Chat notificationsOn" />
						{:else}
							<img src="chatNotificationsOff.svg" alt="Chat notificationsOff" />
						{/if}
					</div>
					Chat Notifications
				</li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<li role="menuitem" tabindex="0" on:click={emailTranscript}>
					<div class="dropdown-item-img">
						<img src="send.svg" alt="Minimize" />
					</div>
					Email Transcript
				</li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<li role="menuitem" tabindex="0" on:click={clearChatHistory}>
					<div class="dropdown-item-img">
						<img src="clearChatHistory.svg" alt="Clear chat history" />
					</div>
					Clear Chat History
				</li>
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<li role="menuitem" tabindex="0" on:click={toggleChatAndEnd}>
					<div class="dropdown-item-img">
						<img src="exitChat.svg" alt="Exit chat" />
					</div>
					Exit Chat
				</li>
			</ul>
		</div>
	</div>
</div>

<script lang="ts">
	import { onMount } from 'svelte';
	import { type Writable } from 'svelte/store';
	import { chatVisible, notificationSoundEnabled, chatSession } from '$lib/stores/chatSessionStore';
	import { resetIframe } from '../../utilities/draggable';
	export let modalId: Writable<string>;
	export let showModal: Writable<boolean>;
	let dropdownOpen = false;

	const toggleNotiications = () => {
		notificationSoundEnabled.update((old) => !old);
	};

	const toggleDropdown = () => {
		dropdownOpen = !dropdownOpen;
	};

	const closeDropdown = (event: MouseEvent) => {
		const target = event.target as HTMLElement;
		if (!target.closest('.dropdown-menu') && !target.closest('.close-button')) {
			dropdownOpen = false;
		}
	};

	const clearChatHistory = () => {
		modalId.update(() => 'clear_history');
		showModal.update(() => true);
	};

	onMount(() => {
		document.addEventListener('click', closeDropdown);

		return () => {
			document.removeEventListener('click', closeDropdown);
		};
	});
	const minimizeChat = () => {
		chatVisible.update((visible) => !visible);
		resetIframe();
	};

	const emailTranscript = () => {
		modalId.update(() => 'email_transcript');
		showModal.update(() => true);
	};

	const toggleChatAndEnd = () => {
		modalId.update(() => 'close_conversation');
		showModal.update(() => true);
	};
</script>

<style>
	.chat-header {
		background-color: #f5f5f5;
		font-weight: bold;
		font-family: area-variable, sans-serif;
		font-style: normal;
		font-variation-settings:
			'INKT' 0,
			'slnt' 0,
			'wdth' 100,
			'wght' 100;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 2px;
		position: relative;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		flex-shrink: 0;
	}
	.chat-header.mobile {
		position: sticky;
		top: 0;
	}
	.header-logo {
		width: 28px;
		height: 28px;
		padding: 10px;
	}
	.image-box {
		display: flex;
		align-items: center;
		padding-right: 10px;
	}
	.buttons {
		display: flex;
	}

	button {
		border: none;
		background: transparent;
		font-size: 16px;
		cursor: pointer;
	}

	.dropdown {
		position: relative;
		display: inline-block;
	}

	.dropdown-menu {
		display: none;
		position: absolute;
		top: 100%;
		right: 0;
		background-color: #ffffff;
		box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		padding: 5px 0;
		width: 220px;
		list-style: none;
		margin: 0;
		z-index: 100;
	}

	.dropdown-menu.open {
		display: block;
	}

	.dropdown-menu[aria-hidden='true'] {
		display: none;
	}

	.dropdown-item-img {
		margin-right: 10px;
		width: 20px;
		height: 20px;
	}

	li {
		padding: 10px 16px;
		cursor: pointer;
		display: flex;
		align-items: center;
		transition: background-color 0.2s ease;
		font-weight: 100;
	}

	li:hover {
		background-color: #f9f9f9;
	}
</style>
